<div id="content">
  <div class="page-title">
    <h1>
      {{ page_title }}
      @if (recording_concept) {
        — {{ recording_concept }}
      }
    </h1>

    <button mat-flat-button type="button" (click)="goBack()">
      <mat-icon>arrow_back</mat-icon>
      Volver
    </button>

    @if (can_edit && interventions_form_array.length > 0) {
      <button mat-flat-button type="button" color="accent" [disabled]="is_saving" (click)="save()">
        <mat-icon>save</mat-icon>
        Guardar
      </button>
    }
  </div>

  @if (is_loading) {
    <div class="page-loading">
      <mat-spinner diameter="36"></mat-spinner>
      <span>Cargando diarización…</span>
    </div>
  } @else if (load_error) {
    <p class="page-error">{{ load_error }}</p>
  } @else if (interventions_form_array.length === 0) {
    <p class="page-empty">No hay intervenciones diarizadas para esta grabación.</p>
  } @else {
    <div class="diarization-layout">
      <section class="diarization-transcript card">
        <h2 class="section-title">Transcripción</h2>

        <form [formGroup]="form" class="diarization-form">
          <div formArrayName="interventions" class="interventions-list">
            @for (intervention_group of interventions_form_array.controls; track $index; let index = $index) {
              <button
                type="button"
                class="intervention-item"
                [class.intervention-item-active]="active_intervention_index() === index"
                [id]="'diarization-intervention-' + index"
                [formGroupName]="index"
                (click)="seekToIntervention(index)"
              >
                <div class="intervention-meta">
                  <span class="intervention-time">
                    {{ formatInterventionTime($safeNavigationMigration(intervention_group.get('start_seconds')?.value)) }}
                    –
                    {{ formatInterventionTime($safeNavigationMigration(intervention_group.get('end_seconds')?.value)) }}
                  </span>
                  <span class="intervention-speaker">{{ intervention_group.get('speaker_label')?.value }}</span>
                </div>
                <p class="intervention-text">{{ intervention_group.get('text')?.value }}</p>
                <mat-form-field class="intervention-user-field" (click)="$event.stopPropagation()">
                  <mat-label>Interviniente</mat-label>
                  <mat-select formControlName="user_id" [disabled]="!can_edit">
                    <mat-option [value]="unassigned_user_option_value">Sin asignar</mat-option>
                    @for (assistant of assistant_users; track assistant.id) {
                      <mat-option [value]="assistant.id">{{ assistant.full_name }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </button>
            }
          </div>
        </form>
      </section>

      <aside class="diarization-sidebar card">
        <h2 class="section-title">Reproducción</h2>

        @if (supports_local_playback) {
          @if (is_loading_playback) {
            <div class="playback-loading">
              <mat-spinner diameter="28"></mat-spinner>
              <span>Cargando audio…</span>
            </div>
          } @else if (playback_error) {
            <p class="playback-error">{{ playback_error }}</p>
          } @else if (playback_object_url) {
            @if (is_audio_fallback_from_youtube) {
              <p class="playback-note">YouTube no disponible. Reproduciendo audio local.</p>
            }
            @if (local_playback_kind === 'audio') {
              <audio #media_player class="media-player" controls [src]="playback_object_url" (timeupdate)="onMediaTimeUpdate()"></audio>
            }
            @if (local_playback_kind === 'video') {
              <video
                #media_player
                class="media-player media-player-video"
                controls
                [src]="playback_object_url"
                (timeupdate)="onMediaTimeUpdate()"
              ></video>
            }
          }
        } @else if (supports_youtube_playback && youtube_video_id) {
          @if (is_loading_youtube) {
            <div class="playback-loading">
              <mat-spinner diameter="28"></mat-spinner>
              <span>Cargando vídeo…</span>
            </div>
          } @else if (youtube_playback_error) {
            <p class="playback-error">{{ youtube_playback_error }}</p>
          }
          <div #youtube_player_container class="youtube-player-container" [class.youtube-player-hidden]="is_loading_youtube"></div>
        } @else {
          <p class="playback-note">No hay archivo de audio disponible para reproducir.</p>
        }

        @if (speaker_labels.length > 0) {
          <h2 class="section-title section-title-spaced">Asignación masiva</h2>
          <p class="bulk-hint">Asigna cada speaker a un asistente; se aplica automáticamente a todos sus fragmentos.</p>

          <form [formGroup]="speaker_bulk_form" class="speaker-bulk-form">
            @for (speaker_label of speaker_labels; track speaker_label) {
              <mat-form-field class="speaker-bulk-field">
                <mat-label>Speaker {{ speaker_label }}</mat-label>
                <mat-select [formControlName]="speaker_label" [disabled]="!can_edit">
                  <mat-option [value]="unassigned_user_option_value">Sin asignar</mat-option>
                  @for (assistant of assistant_users; track assistant.id) {
                    <mat-option [value]="assistant.id">{{ assistant.full_name }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }
          </form>
        }

        @if (is_saving) {
          <mat-progress-bar class="save-progress" mode="indeterminate"></mat-progress-bar>
        }
      </aside>
    </div>
  }
</div>
